export default {"src":"/_next/static/media/toothMagnifying_64.8a9ad247.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};